<template>
  <div class="grid grid-cols-2">
    <div class="w-full border-r-2 border-gray-300 h-screen">
      <div class="overflow-hiddenborder border-gray-100 bg-gray-200 p-0 m-0">
        <ul class="flex items-center text-sm font-medium m-0 ">
          <li>
            <a @click="state.left.activeTab = 0" :class="{ 'active-tab': state.left.activeTab === 0 }" class="inline-flex cursor-pointer items-center gap-2 px-3 py-2 border-b-4 border-transparent hover:text-gray-700"> HTML</a>
          </li>
          <li>
            <a @click="state.left.activeTab = 1" :class="{ 'active-tab': state.left.activeTab === 1 }" class="inline-flex cursor-pointer items-center gap-2 px-3 py-2 border-b-4 border-transparent hover:text-gray-700"> CSS</a>
          </li>
        </ul>
      </div>
      <div class="h-5/6">
        <div :class="{ '!block': state.left.activeTab === 0 }" class="hidden h-full">
          <textarea class="border-none h-full rounded-none focus:border-none focus:shadow-none font-mono" v-model="state.left.htmlContent"></textarea>
        </div>
        <div :class="{ '!block': state.left.activeTab === 1 }" class="hidden h-full">
          <textarea class="border-none h-full rounded-none focus:border-none focus:shadow-none font-mono" v-model="state.left.cssContent"></textarea>
        </div>
        <div class="text-right">
          <button @click="reduce()" class="m-2">Reduce</button>
        </div>
      </div>
    </div>

    <div class="w-full h-screen">
      <div class="overflow-hiddenborder border-gray-100 bg-gray-200 p-0 m-0">
        <ul class="flex items-center text-sm font-medium m-0">
          <li>
            <a @click="state.right.activeTab = 0" :class="{ 'active-tab': state.right.activeTab === 0 }" class="inline-flex cursor-pointer items-center gap-2 px-3 py-2 border-b-4 border-transparent hover:text-gray-700"> HTML</a>
          </li>
          <li>
            <a @click="state.right.activeTab = 1" :class="{ 'active-tab': state.right.activeTab === 1 }" class="inline-flex cursor-pointer items-center gap-2 px-3 py-2 border-b-4 border-transparent hover:text-gray-700"> CSS</a>
          </li>
        </ul>
      </div>
      <div class="h-5/6">
        <div :class="{ '!block': state.right.activeTab === 0 }" class="hidden h-full">
          <textarea class="border-none h-full rounded-none focus:border-none focus:shadow-none font-mono" v-model="state.right.htmlContent"></textarea>
        </div>
        <div :class="{ '!block': state.right.activeTab === 1 }" class="hidden h-full">
          <textarea class="border-none h-full rounded-none focus:border-none focus:shadow-none font-mono" v-model="state.right.cssContent"></textarea>
        </div>
      </div>
    </div>
  </div>


</template>

<script setup>
  import {reactive} from 'vue'
  import _ from 'lodash'

  function cleanMultilineString(str) {
    let lines = str.replace(/^\s*\n/, "")
        .replace(/[\n\s]+$/, "")
        .split("\n")
    let spaces = _.min(lines.map(line => line.match(/\s*/)[0].length))
    lines = lines.map(line => line.slice(spaces))
    return lines.join("\n")
  }

  let state = reactive({
    left: {
      htmlContent: "Input HTML goes here",
      cssContent: "Input CSS is not yet supported",
      activeTab: 0,
    },
    right: {
      htmlContent: "Output HTML will be here",
      cssContent: "Output CSS will be here",
      activeTab: 0,
    }
  })

  state.left.htmlContent = cleanMultilineString(`
    <!-- Example input -->
    <div class="flex flex-wrap items-center justify-center gap-5">
      <button class="rounded-lg bg-blue-500 px-4 py-2 text-white">Blue</button>
      <button class="rounded-lg bg-red-500 px-4 py-2 text-white">Red</button>
      <button class="rounded-lg bg-green-500 px-4 py-2 text-white">Green</button>
    </div>
    `)

  state.right.htmlContent = cleanMultilineString(`
    <!-- Example output -->
    <body xmlns="http://www.w3.org/1999/xhtml"><div class="flex flex-wrap items-center justify-center gap-5">
      <button class="bg-blue-500">Blue</button>
      <button class="bg-red-500">Red</button>
      <button class="bg-green-500">Green</button>
    </div></body>
    `)

  state.right.cssContent = cleanMultilineString(`
    /* Example output */
    button {
      @apply rounded-lg px-4 py-2 text-white;
    }
    `)



  let traverse = (node, nodeList) => {
    if (node.localName === "svg") return
    nodeList[node.localName] ||= {name: node.localName, classes: []}
    nodeList[node.localName].classes.push(node.className)
    if (node.childNodes) {
      node.childNodes.forEach((child) => traverse(child, nodeList))
    }
  }

  let getCommonClasses = (nodeList) => {
    let commonClasses = {}

    for (let key in nodeList) {
      if (key === "undefined") continue
      if (nodeList[key].classes.length > 1) {
        for (let i = 0; i < nodeList[key].classes.length; i++) {
          let classes = nodeList[key].classes[i].split(/\s+/).filter(c => c !== "")
          commonClasses[key] ||= {name: key, classes: classes}
          commonClasses[key].classes = _.intersection(commonClasses[key].classes, classes)
        }
      }
    }
    window.commonClasses = commonClasses
    return commonClasses
  }

  function removeCommonClasses(node, commonClasses) {
    let name = node.localName
    if (commonClasses[name]) {
      let existingClasses = node.className.split(/\s+/)
      let newClasses = _.difference(existingClasses, commonClasses[name].classes)
      node.className = newClasses.join(" ")
    }

    if (node.childNodes) {
      node.childNodes.forEach((child) => removeCommonClasses(child, commonClasses))
    }
  }
  function reduce() {

    let html = state.left.htmlContent
    let css = state.left.cssContent

    let nodeList = {}
    let parsedHtml = new DOMParser().parseFromString(html, "text/html")
    // let parsedCss = new DOMParser().parseFromString(css, "text/css")
    traverse(parsedHtml, nodeList)
    let commonClasses = getCommonClasses(nodeList)
    removeCommonClasses(parsedHtml, commonClasses)
    window.parsedHtml = parsedHtml
    state.right.htmlContent = new XMLSerializer().serializeToString(parsedHtml.body)

    let cssOutput = ""
    for (let key in commonClasses) {
      if (commonClasses[key].classes.length === 0) continue
      cssOutput += cleanMultilineString(`
      ${key} {
        @apply ${commonClasses[key].classes.join(" ")};
      }
      `)
    }
    state.right.cssContent = cssOutput

  }

</script>

<style scoped>
  .active-tab {
    @apply bg-white shadow text-gray-700 border-blue-500;
  }
</style>